import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../styles/HomePage.css';

const HomePage = () => {
  const { user } = useAuth();
  
  return (
    <div className="home-page">
      <div className="hero-section">
        <div className="hero-content">
          <h1>The Icing Calculator</h1>
          <p className="tagline">Take the guesswork out of royal icing prep.</p>

          <div className="benefits-section">
            {/* <h2>Why Use The Icing Calculator?</h2> */}
            
            <div className="benefits-grid">
              <div className="benefit-item">
                <div className="benefit-icon">⏱️</div>
                <h3>Save Time</h3>
                <p>No more guesswork or wasted icing</p>
              </div>
              
              <div className="benefit-item">
                <div className="benefit-icon">🎯</div>
                <h3>Accurate Results</h3>
                <p>Get exact measurements for perfect results</p>
              </div>
              
              <div className="benefit-item">
                <div className="benefit-icon">📱</div>
                <h3>Anywhere Access</h3>
                <p>Works on all devices with a web browser</p>
              </div>
            </div>
          </div>

          <div className="hero-text-columns">
            <div className="text-column-left">
              <h2>Smart Icing, Simplified</h2>
              <p className="hero-description">
                No more running out of icing mid-project. The Icing Calculator helps you estimate just the right amount of royal icing to complete your cookie sets—with a little extra built in for touch-ups, color adjustments, or second chances. Designed with decorators in mind, it’s the smart way to plan your icing—without manually calculating or juggling spreadsheets.
              </p>
              <p className="hero-description">
                Also great for projects using edible ink printing, such as with the Eddie printer, where designs often rely entirely on flood icing.
              </p>
            </div>
            <div className="text-column-right">
              <div className="hero-features-list">
                <h2>Here’s what it does:</h2>
                <ul>
                  <li>Estimates icing amounts based on cookie size</li>
                  <li>Basic calculator works for one cookie shape at a time</li>
                  <li>Beta Pro version includes multi-shape and multi-color support</li>
                  <li>Designed for royal icing at flood consistency (based on 15–20 second flood, glob or ribbon style; your icing consistency may vary—adjust as needed for your specific recipe or technique)</li>
                  <li>For outline and detail work, just add a few extra ounces to your total.</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="hero-image">
            <img 
              src="/images/hero-screenshot.png" 
              alt="Cookie Icing Calculator Preview"
              className="hero-preview"
            />
          </div>
        </div>
        
        <div className="hero-features">
          <div className="feature-card">
            <div className="feature-icon">🧮</div>
            <h3>Basic Calculator</h3>
            <p>Calculate icing needed based on a reference cookie</p>
            <Link to="/basic" className="feature-link">
              Use Basic Calculator
            </Link>
          </div>
          
          <div className="feature-card pro">
            <div className="feature-icon">⚡</div>
            <h3>Pro Calculator</h3>
            <p>Advanced features for professional bakers</p>
            {user ? (
              <Link to="/pro" className="feature-link">
                Use Pro Calculator
              </Link>
            ) : (
              <Link to="/login" className="feature-link">
                Login to Access
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
